<template>
  <div :style="SwiperImgStyle" :class="SwiperImgClass">
    <el-carousel :interval="5000" arrow="never" indicator-position="none" @change="change">
      <el-carousel-item v-for="item in detailData.cateList" :key="item">
        <el-image
          :src="item.logo"
          :fit="'fit'"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div class="text" v-if="pattern.isShow&&pattern.styleType==3">
      {{ index+1 }}/{{ detailData.cateList.length }}
    </div>
    <div class="dotList" v-if="pattern.isShow&&pattern.styleType!=3">
      <span :class="[{'on':i == index},{'long':pattern.styleType==2}]" v-for="(item,i) in detailData.cateList" :key="i"></span>
    </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'SwiperImg',
  props: {},
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
        cateList: []
      },
      pattern: {},
      index: 0,
      timer: null,
    }
  },
  watch: {
  },
  computed: {
    SwiperImgClass(){
      return this.pattern.type == 2 ? 'SwiperImg height' : 'SwiperImg'
    },
    SwiperImgStyle(){
      return {
        "margin-left": (this.pattern.margin == undefined ? 18 : this.pattern.margin) + 'px',
        "margin-right": (this.pattern.margin == undefined ? 18 : this.pattern.margin) + 'px',
        "border-radius": this.pattern.type == 2 ? '0' : '6px'
      }
    }
  },
  methods: {
    change(val){
      this.index = val
    },
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      if(this.pattern.margin == undefined){
        this.pattern.margin = 18
      }
      console.log("SwiperImg----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss">
  .SwiperImg{
    overflow: hidden;
    position: relative;
    .el-image{
      height: 100%;
      img{
        object-fit: cover;
      }
    }
    .el-carousel__container{
      height: 168px;
    }
    &.height .el-carousel__container{
      height: 330px;
    }
    .text{
      position: absolute;
      right: 20px;
      bottom: 10px;
      border-radius: 6px;
      border: 1px solid #FFFFFF;
      color: #FFFFFF;
      padding: 3px 7px;
      z-index: 9;
    }
    .dotList{
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
      span{
        width: 8px;
        height: 8px;
        background: #0000001a;
        border: 1px solid #ffffff69;
        margin-right: 3px;
        display: inline-block;
        border-radius: 50%;
        &.long{
          height: 4px;
          width: 16px;
          border-radius: 0;
        }
        &.on{
          background: #FFFFFF;
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
</style>
